var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.html)?_c('div',{class:_vm.classes,domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('div',{class:_vm.classes},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.isCollapsable)?_c('b-button',{staticClass:"mt-20",attrs:{"variant":"link"},on:{"click":function($event){_vm.showCollapse = !_vm.showCollapse}}},[_vm._v("Read "+_vm._s(_vm.showCollapse ? 'less' : 'more')+"\n    "),_c('i',{class:[
        'icon',
        {
          'icon-caret': !_vm.showCollapse,
          'icon-caret-up': _vm.showCollapse
        }
      ]})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }